export function getCart(sessionOrCartId, storeCode) {


    const endpoint = `/${storeCode}/V1/xapi/cart/${sessionOrCartId && sessionOrCartId.accessToken ? 'mine' : sessionOrCartId}`;
    const options = {
        method: 'GET'
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}

export function addProductToCart(sessionOrCartId, sku, qty = 1, customOptions = [], storeCode) {
    const endpoint = `/${storeCode}/V1/xapi/cart/${sessionOrCartId ? (sessionOrCartId.accessToken ? 'mine' : sessionOrCartId) : 'none'}/items`;

    const buildCustomOptionsData = () => {

        if (Object.keys(customOptions).length === 0) return {};

        let customOptionsJson = [];

        customOptions.map(option => {
            customOptionsJson.push({
                "option_id": option.option_id,
                "option_value": option.value
            });
        });

        return {
            "product_option": {
                "extension_attributes": {
                    "custom_options": customOptionsJson
                }
            }
        };

    }

    const options = {
        method: 'POST',
        data: {
            "cartItem": {
                "sku": sku,
                "qty": qty,
                /* "quote_id": quoteId,*/
                ...buildCustomOptionsData()
            }
        }
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}


export function updateCartItem(sessionOrCartId, itemId, qty = 1, customOptions = {}, storeCode) {
    const endpoint = `/${storeCode}/V1/xapi/cart/${sessionOrCartId && sessionOrCartId.accessToken ? 'mine' : sessionOrCartId}/items/${itemId}`;

    const buildCustomOptionsData = () => {

        if (Object.keys(customOptions).length === 0) return {};

        let customOptionsJson = [];

        customOptions.map(option => {
            customOptionsJson.push({
                "option_id": option.option_id,
                "option_value": option.value
            });
        });

        return {
            "product_option": {
                "extension_attributes": {
                    "custom_options": customOptionsJson
                }
            }
        };

    }

    const options = {
        method: 'PUT',
        data: {
            "cartItem": {
                "item_id": itemId,
                "qty": qty,
                ...buildCustomOptionsData()
            }
        }
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}


export function removeProductFromCart(sessionOrCartId, itemId, storeCode) {
    const endpoint = `/${storeCode}/V1/xapi/cart/${sessionOrCartId && sessionOrCartId.accessToken ? 'mine' : sessionOrCartId}/items/${itemId}`;
    const options = {
        method: 'DELETE'
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}


/*export function getCartPaymentMethods(sessionOrCartId, storeCode) {
    const endpoint = sessionOrCartId && sessionOrCartId.accessToken ? `/${storeCode}/V1/carts/mine/payment-methods` : `/${storeCode}/V1/guest-carts/${sessionOrCartId}/payment-methods`;

    const options = {
        method: 'GET'
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}*/

export function estimateShippingMethods(sessionOrCartId, address, storeCode) {
    const endpoint = sessionOrCartId && sessionOrCartId.accessToken ? `/${storeCode}/V1/carts/mine/estimate-shipping-methods` : `/${storeCode}/V1/guest-carts /${sessionOrCartId}/estimate-shipping-methods`;

    const options = {
        method: 'POST',
        data: {
            address: {
                region: address.region,
                region_id: address.region_id,
                region_code: address.region_code,
                country_id: address.country_id,
                street: address.street,
                postcode: address.postcode,
                city: address.city,
                firstname: address.firstname,
                lastname: address.lastname,
                email: address.email,
                telephone: address.telephone,
                vat_id: address.vat_id,
                company: address?.company,
                extension_attributes: {
                    pec: billing?.invoice_request && billing?.invoice_request == '1' ? address?.pec ?? '' : '',
                    sdi: billing?.invoice_request && billing?.invoice_request == '1' ? address?.sdi ?? '' : '',
                    invoice_request: billing?.invoice_request && billing?.invoice_request == '1' ? 1 : 0,
                    fiscal_code: billing?.fiscal_code ?? ''
                }
            }
        }
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}


export function setShippingInformation(sessionOrCartId, billing, shipping, shippingCarrier, shippingMethod, storeCode) {
    const endpoint = sessionOrCartId && sessionOrCartId.accessToken ? `/${storeCode}/V1/carts/mine/shipping-information` : `/${storeCode}/V1/guest-carts/${sessionOrCartId}/shipping-information`;

    const options = {
        method: 'POST',
        data: {
            addressInformation: {
                shipping_address: {
                    region: shipping.region,
                    region_id: shipping.region_id,
                    region_code: shipping.region_code,
                    country_id: shipping.country_id,
                    street: shipping.street/*, shipping.street_number*/,
                    postcode: shipping.postcode,
                    city: shipping.city,
                    firstname: shipping.firstname,
                    lastname: shipping.lastname,
                    email: shipping.email,
                    telephone: shipping.telephone,
                    save_in_address_book: shipping?.save_in_address_book ?? 0,
                    same_as_billing: shipping?.same_as_billing ?? 0,
                },
                billing_address: {
                    region: billing.region,
                    region_id: billing.region_id,
                    region_code: billing.region_code,
                    country_id: billing.country_id,
                    street: billing.street/*,billing.street_number*/,
                    postcode: billing.postcode,
                    city: billing.city,
                    firstname: billing.firstname,
                    lastname: billing.lastname,
                    email: billing.email,
                    telephone: billing.telephone,
                    vat_id: billing.vat_id,
                    company: billing?.company,
                    same_as_billing: billing?.same_as_billing ?? 0,
                    save_in_address_book: billing?.save_in_address_book ?? 0,
                    extension_attributes: {
                        pec: billing?.invoice_request && billing?.invoice_request == '1' ? billing?.pec ?? '' : '',
                        sdi: billing?.invoice_request && billing?.invoice_request == '1' ? billing?.sdi ?? '' : '',
                        invoice_request: billing?.invoice_request && billing?.invoice_request == '1' ? 1 : 0,
                        fiscal_code: billing?.fiscal_code ?? ''
                    }
                },
                shipping_carrier_code: shippingCarrier,
                shipping_method_code: shippingMethod
            }
        }
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}


export function setPaymentInformation(sessionOrCartId, paymentMethod, billing, additionalData = {}, storeCode) {
    const endpoint = sessionOrCartId && sessionOrCartId.accessToken ? `/${storeCode}/V1/xapi/cart/mine/payment-information` : `/${storeCode}/V1/xapi/cart/${sessionOrCartId}/payment-information`;

    const options = {
        method: 'POST',
        data: {
            paymentMethod: {
                method: paymentMethod,
                additional_data: additionalData
            },
            billing_address: {
                region: billing.region,
                region_id: billing.region_id,
                region_code: billing.region_code,
                country_id: billing.country_id,
                street: billing.street/*,billing.street_number*/,
                postcode: billing.postcode,
                city: billing.city,
                firstname: billing.firstname,
                lastname: billing.lastname,
                email: billing.email,
                telephone: billing.telephone,
                vat_id: billing.vat_id ?? '',
                company: billing?.company ?? '',
                same_as_billing: billing?.same_as_billing ?? 0,
                save_in_address_book: billing?.save_in_address_book ?? 0,
                extension_attributes: {
                    pec: billing?.invoice_request ? billing?.pec ?? '' : '',
                    sdi: billing?.invoice_request ? billing?.sdi ?? '' : '',
                    invoice_request: billing?.invoice_request ?? 0,
                    fiscal_code: billing?.fiscal_code ?? ''
                }
            },
            email: billing.email
        }
    };

    if (sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}

export function sendQuotationRequest(sessionOrCartId, email, storeCode, beEmail = false, bePrefix = '') {
    const endpoint = sessionOrCartId && sessionOrCartId.accessToken ? `/${storeCode}/V1/carts/mine/quotation` : `/${storeCode}/V1/carts/${sessionOrCartId}/quotation`;

    const data = beEmail ? {
        email, beEmail, bePrefix
    } : {email};

    const options = {
        method: 'POST',
        data: data
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];

}

export function loadQuotationRequest(sessionOrCartId, incrementId, storeCode) {
    const endpoint = sessionOrCartId && sessionOrCartId.accessToken ? `/${storeCode}/V1/quotation/mine/load/${incrementId}` : `/${storeCode}/V1/quotation/load/${incrementId}`;

    const options = {
        method: 'GET'
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];

}


export function setCartCouponCode(sessionOrCartId, couponCode, storeCode) {
    const endpoint = sessionOrCartId && sessionOrCartId.accessToken ? `/${storeCode}/V1/xapi/cart/mine/set-coupon/${couponCode}` : `/${storeCode}/V1/xapi/cart/${sessionOrCartId}/set-coupon/${couponCode}`;

    const options = {
        method: 'GET'
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}

export function removeCartCouponCode(sessionOrCartId, storeCode) {
    const endpoint = sessionOrCartId && sessionOrCartId.accessToken ? `/${storeCode}/V1/xapi/cart/mine/remove-coupon` : `/${storeCode}/V1/xapi/cart/${sessionOrCartId}/remove-coupon`;

    const options = {
        method: 'GET'
    };

    if (sessionOrCartId && sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}

export function quotationCheckPw(storeCode, pw) {
    const endpoint = `/${storeCode}/V1/xapi/quotations/checkPw/${pw}`;
    const options = {
        method: 'GET'
    };

    return [endpoint, options];
}
